<template>
  <div class="" v-loading.fullscreen.lock="loader">
    <div class="card">
       <div class="section-heading" align="center">ASSIGN TEST TO CAMPUS</div>
       <div style="margin-top:2rem;">
        <el-form ref="form" class="row" :model="form" :rules="rules" label-width="120px" label-position="top">
          <el-form-item class="col-md-6" label="Campus Name" prop="AssignSurveyRole">
            <el-select v-model="form.AssignSurveyRole"  placeholder="Select Campus">
              <el-option
                v-for="(item, key) in surveyRolesList"
                :key="key"
                :label="key"
                :value="key">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="col-md-6" label="Test Set" prop="SurveyGroupId">
            <el-select v-model="form.SurveyGroupId" placeholder="Select Test Set">
              <el-option
                v-for="(item, key) in surveyGroup"
                :key="key"
                :label="item.name"
                :value="key">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <br>
        <div align="right">
          <el-button class="btn-theme" @click="assignSurvey('form')">Submit Test</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'CreateSurveyGroup',
  data () {
    return {
      surveyGroup: [],
      surveyRolesList: [],
      loader: false,
      form: {
        AssignSurveyRole: '',
        SurveyGroupId: ''
      },
      rules: {
        AssignSurveyRole: [
          { required: true, message: 'Select Campus', trigger: 'change' }
        ],
        SurveyGroupId: [
          { required: true, message: 'Select Test Set Name', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters({
      getSurveyRoles: 'Survey/getSurveyRoles',
      getSurveyGroup: 'Survey/getSurveyGroup'
    })
  },
  methods: {
    ...mapActions({
      fetchSurveyRoles: 'Survey/fetchSurveyRoles',
      assignSurveyByRole: 'Survey/assignSurveyByRole',
      fetchSurveyGroup: 'Survey/fetchSurveyGroup'
    }),
    assignSurvey (form) {
      // this.loader = true
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.assignSurveyByRole({
            role: this.form.AssignSurveyRole,
            group_id: this.form.SurveyGroupId
          })
          this.$refs[form].resetFields()
          this.$message.success('Test assigned successfully')
        } else {
          console.log('error submit!!')
          return false
        }
      })
      var that = this
      setTimeout(function () { that.loader = false }, 500)
    }
  },
  watch: {
    getSurveyRoles (value) {
      if (value === 'Error') {
        this.$message.error('Try Again...')
      } else if (value.success === true) {
        this.surveyRolesList = value.data
      } else {
        this.$message.error(value.message)
      }
      this.loader = false
    },
    surveyRolesList (value) {
      this.loader = false
    },
    getSurveyGroup (value) {
      if (value === 'Error') {
        this.$message.error('Try Again...')
      } else if (value.success === true) {
        this.surveyGroup = value.data
      } else {
        this.$message.error(value.message)
      }
    }
  },
  mounted () {
    this.loader = true
    this.fetchSurveyRoles()
    this.fetchSurveyGroup()
  }
}
</script>
<style>
.el-form-item {
  margin-bottom: 0;
}
.el-form--label-top .el-form-item__label {
  padding: 0;
}
.el-form-item__label {
  font-size: 18px;
  padding: 10px 0;
  font-weight: 300;
  color: #67757c;
}
.el-select {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/SurveyGroup/AssignSurveyByRole.vue